import { Footer } from 'components/footer';
import { PotreeContainer } from 'containers/PotreeContainer';

import useSharePointCloudHandlers from './useSharePointCloudHandlers';

export default function SharePointCloud() {
    const { isError, errorMsg, roleTitle } = useSharePointCloudHandlers();

    return (
        <div>
            <PotreeContainer isError={isError} errorMsg={errorMsg} />
            <Footer mode="share" roleTitle={roleTitle} />
        </div>
    );
}
